<template>
  <div>
    <div class="topTitle ">
      <el-page-header @back="goBack" content="我创建的比赛">
      </el-page-header>

    </div>

    <div class="OJProblemManagement">

      <div class="clearfix top" style="margin-bottom: 20px;">
        <div class="fl" style="margin-right:10px">
          <el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入比赛名称" size="small" clearable
            @keyup.enter.native="tchGetOwnOjContestList"></el-input>
        </div>

        <div class="fl">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="goNext">新增比赛</el-button>
        </div>

      </div>
      <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{
        background: '#f5f7fa',
        color: '#606266',
        'font-size': '14px',
      }">
        <el-table-column width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no - 1) * page_size }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="" label="比赛状态">
          <template slot-scope="scope">
            <span v-if="scope.row.typetime === '进行中'" style="color:#67C23A">进行中</span>
            <span v-if="scope.row.typetime === '未开始'" style="color:#67C23A">未开始</span>
            <span v-if="scope.row.typetime === '已结束'" style="color:red;">已结束</span>
          </template>
        </el-table-column>

        <el-table-column prop="title" label="比赛名称" show-overflow-tooltip width="200">
          <template slot-scope="scope">
            <el-link @click="goProblem1(scope.row)">{{
              scope.row.title
            }}</el-link>
          </template>

        </el-table-column>

        <el-table-column prop="rule_type" label="赛制">
          <template slot-scope="scope">
            <span v-if="scope.row.rule_type === 1">ACM</span>
            <span v-if="scope.row.rule_type === 2">OI</span>
            <span v-if="scope.row.rule_type === 3">IOI</span>
          </template>
        </el-table-column>

        <el-table-column prop="signCountNum" align="center" label="人数">
        </el-table-column>

        <el-table-column prop="start_date" label="起止时间" show-overflow-tooltip width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.start_date.slice(0, 16) + ' - ' + scope.row.end_date.slice(0, 16) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否可见">
          <template slot-scope="scope">
            <span v-if="scope.row.post_state == true">可见</span>
            <span v-if="scope.row.post_state == false">不可见</span>
          </template>
        </el-table-column>

        <el-table-column label="开放报名">
          <template slot-scope="scope">
            <el-switch @change="changeSwitchState(scope.row)" v-model="scope.row.sign_state">
            </el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="end_date" label="结束时间" show-overflow-tooltip>
        </el-table-column> -->
        <!-- 
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.post_state===true">开启</span>
            <span v-if="scope.row.post_state===false">关闭</span>
          </template>

        </el-table-column> -->
        <el-table-column label="操作" width="250px">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="goProblem(scope.row)">题目</el-button>
            <el-button type="text" size="mini" @click="user(scope.row)">人员</el-button>

            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="goRanking(scope.row)">排行</el-button>
            <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>

          </template>
        </el-table-column>
      </el-table>
      <div class="clearfix" style="margin-top: 20px;">
        <div class="fr" style=" text-align: right">
          <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size"
            layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  tchGetOwnOjContestList,
  tchDeleteOjContest,
  // tchUpdateOjContestPostState,
  tchUpdateOjContestSignState
}
  from "@/api/educational.js";
export default {
  data() {
    return {
      form: {
        resource: '',
        resource1: ''

      },
      page_no: 1,
      page_size: 20,
      total: 20,
      keyword: '',
      tableData: [],
      url: ''
    }
  },
  mounted() {
    this.tchGetOwnOjContestList()
  },
  methods: {
    goProblem1(row) {
      sessionStorage.setItem("matchDetails", JSON.stringify(row));
      this.$router.push({
        name: "matchDetails",
        query: {
          typeNext: 'MyMatch',
          id: row.id,
          educational_institution_id: row.educational_institution_id,
          title: row.title,
          typetime: row.typetime,
          end_date: row.end_date,
          rule_type1: row.rule_type,
          start_date: row.start_date,
          languages: JSON.stringify(JSON.parse(row.languages)),
          sponsor: row.sponsor,
        },
      });
    },
    goRanking(val) {
      this.url =
        "/MyMatchRanking?id=" + val.id + '&startTime=' + val.start_date + '&endTime=' + val.end_date
      console.log(this.url, 1245)
      window.open(this.url, "_blank");
      console.log(val)
      // this.$router.push({
      //   name: 'MyMatchRanking',
      //   query: {
      //     id: val.id,
      //     startTime: val.start_date,
      //     endTime: val.end_date,
      //   }
      // })
    },
    changeSwitchState(val) {
      let sign_state1 = 0
      if (val.sign_state == true) {
        sign_state1 = 1
      } else {
        sign_state1 = 0
      }
      console.log(sign_state1)
      tchUpdateOjContestSignState({
        contest_id: val.id,
        sign_state: sign_state1
      }).then((res) => {
        console.log(res)
        this.tchGetOwnOjContestList()
        if (sign_state1 == 0) {
          this.$message.success('报名已关闭')
        } else {
          this.$message.success('报名已开启')

        }

      })
    },
    // changeSwitch(val) {
    //   console.log(val, 123456)
    //   let post_state1 = 0
    //   if (val.post_state == true) {
    //     post_state1 = 1
    //   } else {
    //     post_state1 = 0
    //   }
    //   console.log(post_state1)
    //   tchUpdateOjContestPostState({
    //     contest_id: val.id,
    //     post_state: post_state1
    //   }).then((res) => {
    //     console.log(res)
    //     this.tchGetOwnOjContestList()
    //     if (post_state1 == 0) {
    //       this.$message.success('比赛已关闭')
    //     } else {
    //       this.$message.success('比赛开启')

    //     }

    //   })
    // },
    search() {
      this.page_no = 1
      this.tchGetOwnOjContestList()
    },
    goBack() {
      // this.$router.go(-1)
      this.$router.push({
        name: 'match'
      })
    },
    del(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tchDeleteOjContest({
          id: row.id,
          ifIgnore: 0
        }).then((res) => {

          if (res.is_delete === true) {
            this.$message.success("删除成功");
            this.tchGetOwnOjContestList()
          } else {
            this.$confirm(res.msg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              tchDeleteOjContest({
                id: row.id,
                ifIgnore: 1
              }).then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.tchGetOwnOjContestList()
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },

    edit(row) {
      sessionStorage.setItem('addMatch', JSON.stringify(row))
      this.$router.push({
        name: 'addMatch',
        query: {
          type: 'edit'
        }
      })

    },
    tchGetOwnOjContestList() {
      tchGetOwnOjContestList({
        title_code: this.keyword,
        isPlatform: this.form.isPlatform,
        page_no: this.page_no,
        page_size: this.page_size
      }).then((res) => {
        console.log(res)
        this.tableData = res.ojContestList
        this.total = res.total
        const yy = new Date().getFullYear()
        const MM = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)
        const dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
        const HH = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
        const mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
        const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
        // return yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
        let newTime = yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
        // let newTime1 = yy + '-' + MM + '-' + dd + ' ' + '00' + ':' + '00' + ':' + '00'

        this.tableData.map((item) => {
          if (item.start_date > newTime) {
            item.typetime = '未开始'
          } else if (item.start_date < newTime && item.end_date > newTime) {
            item.typetime = '进行中'
          } else if (item.end_date < newTime) {
            item.typetime = '已结束'
          }
        })
        console.log(this.tableData, 1245)

      })
    },
    goNext() {
      this.$router.push({
        name: 'addMatch'
      })
    },
    // add() {
    //   this.$router.push({
    //     name: 'addCompetitionManagement'
    //   })
    // },
    handleCurrent(val) {
      this.page_no = val
      this.tchGetOwnOjContestList()
    },
    goProblem(row) {
      this.$router.push({
        name: 'addMatchProblem',
        query: {
          id: row.id
        }
      })
    },
    user(row) {
      this.$router.push({
        name: 'addUser',
        query: {
          id: row.id
        }
      })

    }


  }

}
</script>
<style lang="scss" scoped>
.OJProblemManagement {
  margin: 10px;
  padding: 20px;

  background: white;
  border-radius: 5px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.top {
  font-size: 18px;
  font-weight: 300;
}

/deep/ .el-radio-group {
  margin-top: 7px;
}

/deep/ .el-divider--horizontal {
  margin-top: 0px;
}

.topTitle {
  height: 60px;
  background: #fff;

  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-size: 12px;
  padding-right: 5px;
  padding-left: 10px;
}
</style>